import { Route, NavigationGuardNext } from 'vue-router';
import store from '@/store';
import { Page } from '@/store/profile/types';

// isAuthSession
export default async function (to: Route, from: Route, next: NavigationGuardNext): Promise<void> {
  const session = await store.dispatch('profile/getSession');
  if (session) {
    const pages = await store.getters['profile/getPages'];
    const currentPage: Page = pages.find((v: Page) => v.to.name === to.name && v.to?.params?.entityName === to?.params?.entityName);
    if (currentPage && !currentPage.isAllowed) {
      let newTo: any = { name: 'AccessDenied' };
      if (from.name === 'Login') {
        const firstAvailablePage = pages.find((v: Page) => v.isAllowed);
        if (firstAvailablePage && firstAvailablePage.to) {
          newTo = firstAvailablePage.to;
        }
      }
      next(newTo);
      return;
    }
    next();
    if (to.name === 'Login') {
      next({ name: 'Dashboard' });
    }
  } else if (to.name !== 'Login') {
    next({ name: 'Login' });
  } else {
    next();
  }
}
